import Swal from 'sweetalert2';

/**
 * Genel bir hata mesajını SweetAlert2 ile gösterir.
 * @param {string} title Başlık
 * @param {string} message Gösterilecek mesaj
 * @param {string} [icon='error'] 'success', 'error', 'warning', 'info', 'question'
 */
export const showErrorAlert = (title, message, icon = 'error') => {
    Swal.fire({
        title: title,
        html: message, // HTML içeriğe izin vermek için html kullanıyoruz
        icon: icon,
        confirmButtonText: 'Tamam',
        customClass: {
            confirmButton: 'btn btn-primary' // Buton stili için (Bootstrap vb. varsa)
        },
        buttonsStyling: false // Kendi stilimizi kullanmak için
    });
};

/**
 * API'den dönen standart hata modelini işleyip SweetAlert2 ile gösterir.
 * @param {object} errorResponse Backend'den dönen ErrorResponseModel objesi veya benzeri
 * @param {string} [defaultTitle='Bir Hata Oluştu'] Varsayılan başlık
 */
export const handleApiErrorAlert = (errorResponse, defaultTitle = 'Bir Hata Oluştu') => {
    let title = defaultTitle;
    let message = 'İşleminiz gerçekleştirilirken beklenmedik bir sorun oluştu. Lütfen daha sonra tekrar deneyin.';
    let icon = 'error';

    if (errorResponse) {
        message = errorResponse.message || message;

        if (errorResponse.errorCode) {
            switch (errorResponse.errorCode) {
                case 'INSUFFICIENT_FUNDS':
                    title = 'Yetersiz Bakiye';
                    icon = 'warning';
                    break;
                case 'INVALID_CARD_NUMBER':
                    title = 'Geçersiz Kart Bilgileri';
                    icon = 'warning';
                    break;
                case 'CONFIG_ERROR':
                    title = 'Yapılandırma Hatası';
                    icon = 'error';
                    break;
                case 'INVALID_CALLBACK':
                    title = 'Geçersiz İşlem';
                    icon = 'error';
                    message = errorResponse.message || 'Ödeme işlemi tamamlanamadı veya geçersiz parametrelerle çağrıldı.';
                    break;
                case 'INVALID_WEBHOOK_PAYLOAD':
                    title = 'Geçersiz Bildirim';
                    icon = 'warning';
                    break;
                default:
                    break;
            }
        }
        
        if (errorResponse.errors && typeof errorResponse.errors === 'object' && Object.keys(errorResponse.errors).length > 0) {
            let validationMessages = '<ul style="text-align: left; margin-top: 10px;">';
            for (const key in errorResponse.errors) {
                if (Array.isArray(errorResponse.errors[key])) {
                    errorResponse.errors[key].forEach(errMsg => {
                        validationMessages += `<li>${errMsg}</li>`;
                    });
                } else {
                     validationMessages += `<li>${errorResponse.errors[key]}</li>`;
                }
            }
            validationMessages += '</ul>';
            message += validationMessages;
        }
    }

    showErrorAlert(title, message, icon);
};

/**
 * Onay modalı gösterir ve kullanıcının onaylaması veya iptal etmesi durumunu döndürür.
 * @param {string} title Modal başlığı
 * @param {string} text Modal içeriğindeki metin
 * @param {string} confirmButtonText Onay butonunda gösterilecek metin
 * @param {string} cancelButtonText İptal butonunda gösterilecek metin
 * @param {string} [icon='warning'] Modal ikonu - 'warning', 'error', 'success', 'info', 'question'
 * @returns {Promise<boolean>} Kullanıcının seçimi - true: onaylandı, false: iptal edildi
 */
export const confirmAlert = (title, text, confirmButtonText, cancelButtonText, icon = 'warning') => {
  return new Promise((resolve) => {
    Swal.fire({
      title: title,
      text: text,
      icon: icon,
      showCancelButton: true,
      confirmButtonColor: '#dc3545', // Tehlikeli işlemler için kırmızı
      cancelButtonColor: '#6c757d', // İptal için gri
      confirmButtonText: confirmButtonText,
      cancelButtonText: cancelButtonText,
      customClass: {
        confirmButton: 'btn btn-danger mx-2',
        cancelButton: 'btn btn-secondary mx-2',
      },
      buttonsStyling: false
    }).then((result) => {
      resolve(result.isConfirmed);
    });
  });
};

/**
 * Başarılı işlem mesajını SweetAlert2 ile gösterir.
 * @param {string} title Başlık
 * @param {string} message Gösterilecek mesaj
 */
export const showSuccessAlert = (title, message) => {
    Swal.fire({
        title: title,
        text: message,
        icon: 'success',
        confirmButtonText: 'Tamam',
        customClass: {
            confirmButton: 'btn btn-primary'
        },
        buttonsStyling: false
    });
}; 